// Money going out on construction: vendor material bills and salaries on the payroll.

export type CostBill = { id: string; invoiceDate?: string; invoiceTotal?: number; calculatedTotal?: number; vendor?: string };
export type CostEmployee = { id: string; active?: boolean; monthlySalary?: number };

const billAmount = (b: CostBill) => {
  const total = Number(b.invoiceTotal);
  return Number.isFinite(total) && total > 0 ? total : Math.max(0, Number(b.calculatedTotal) || 0);
};

export function buildCostSummary(bills: CostBill[], employees: CostEmployee[], now: Date = new Date()) {
  const ym = (d: Date) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
  const thisMonth = ym(now);
  const prevMonth = ym(new Date(now.getFullYear(), now.getMonth() - 1, 1));
  const fyStart = `${now.getMonth() >= 3 ? now.getFullYear() : now.getFullYear() - 1}-04`;
  let total = 0;
  let month = 0;
  let prev = 0;
  let fy = 0;
  let monthCount = 0;
  const vendors = new Map<string, number>();
  bills.forEach((b) => {
    const amount = billAmount(b);
    if (!amount) return;
    const key = String(b.invoiceDate || '').slice(0, 7);
    total += amount;
    if (key === thisMonth) {
      month += amount;
      monthCount += 1;
    }
    if (key === prevMonth) prev += amount;
    if (key >= fyStart) {
      fy += amount;
      const vendor = String(b.vendor || '').trim() || 'Vendor not named';
      vendors.set(vendor, (vendors.get(vendor) || 0) + amount);
    }
  });
  const staff = employees.filter((e) => e.active !== false);
  return {
    materials: { total, month, prev, fy, monthCount, billCount: bills.length },
    salaries: { monthly: staff.reduce((s, e) => s + Math.max(0, Number(e.monthlySalary) || 0), 0), staff: staff.length },
    topVendors: Array.from(vendors.entries()).sort((a, b) => b[1] - a[1]).slice(0, 4),
  };
}

export type CostSummary = ReturnType<typeof buildCostSummary>;
